exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".password-input {\r\n    position: relative;\r\n  }\r\n  \r\n  .password-toggle {\r\n    position: absolute;\r\n    right: 10px;\r\n    top: 50%;\r\n    -webkit-transform: translateY(-50%);\r\n            transform: translateY(-50%);\r\n    cursor: pointer;\r\n  }\r\n  \r\n  .password-toggle i {\r\n    font-size: 20px;\r\n  }", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/xampp/htdocs/projects/angular.casherpay.stgnew/angular.casherpay/src/app/resetpassword/resetpassword.component.css
// module id = ../../../../../src/app/resetpassword/resetpassword.component.css
// module chunks = main